import { Card, Divider, Skeleton, message } from "antd"
import TimesheetLockingForm from "pages/settings/components/timesheet-locking-form"
import { IFormObject } from "pages/settings/components/workspace-settings-form"
import { useCurrentUser } from "hooks/current-user"
import { useSettings, useUpdateSettings } from "hooks/settings"

const TimesheetLockingSection = () => {
  const { settings, loading, fetchSettings } = useSettings()
  const { updateSettings, loading: updating } = useUpdateSettings()

  const { currentUser } = useCurrentUser()

  if (settings === undefined || !currentUser) return (
    <Card style={{
      width: '400px',
    }}>
      <Skeleton />
    </Card>
  )

  const initialValues = { ...settings, name: currentUser.account?.name }

  const handleSubmit = async (settings: IFormObject) => {
    const response = await updateSettings(settings)

    if (response.ok) {
      message.success("Timesheet locking settings updated!")
      await fetchSettings()
    }

    return response
  }

  return (
    <Card
      style={{
        width: '400px',
      }}
    >
        <h2>
          Timesheet locking
        </h2>

        <Divider style={{ marginTop: 0 }}/>

        <TimesheetLockingForm
          initialValues={initialValues}
          onSubmit={handleSubmit}
        />
 
    </Card>
  )
}

export default TimesheetLockingSection